/* eslint-disable indent */
import React, { useCallback, useEffect, useState } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { TextField, InputAdornment, IconButton, Box, useTheme } from '@mui/material';
import { useInstantSearch, useSearchBox } from 'react-instantsearch';
import { useDispatch } from 'react-redux';
import { setSearchText } from '@/features/table/instantSearchSlice';

const SearchField = ({ value, onChange, onClick, disabled, onReset, onKeyDown, helperText }) => {
	const theme = useTheme();
	return (
		<TextField
			id='table-search-field'
			placeholder='Search'
			value={value}
			onChange={onChange}
			onKeyDown={onKeyDown}
			onBlur={onClick}
			disabled={disabled}
			helperText={helperText ?? 'Press enter to search'}
			fullWidth
			size='small'
			slotProps={{
				formHelperText: {
					style: { color: theme.palette.text.secondary },
				},
				input: {
					startAdornment: (
						<InputAdornment position='start'>
							<IconButton disabled={disabled} sx={{ padding: '0' }} onClick={onClick}>
								<SearchIcon />
							</IconButton>
						</InputAdornment>
					),
					endAdornment: (
						<InputAdornment position='end'>
							{value && value.length > 0 && (
								<IconButton
									size='small'
									disabled={disabled}
									sx={{ padding: '0' }}
									onClick={onReset}
								>
									<ClearIcon fontSize='20px' />
								</IconButton>
							)}
						</InputAdornment>
					),
				},
			}}
			// sx={{
			// 	mt: '4px',
			// }}
		/>
	);
};

SearchField.displayName = 'SearchField';

const InstantSearchField = ({ query, isSearchStalled, refine, disabled }) => {
	const { refresh } = useInstantSearch();
	const dispatch = useDispatch();

	useEffect(() => {
		refresh();
		dispatch(setSearchText(''));
	}, []);

	const handleChange = (e) => {
		const value = e.currentTarget.value;
		refine(value);
		dispatch(setSearchText(value));
	};

	const handleClear = () => {
		refine('');
		dispatch(setSearchText(''));
	};

	return (
		<TextField
			id='table-search-field'
			placeholder='Search'
			value={query}
			onChange={handleChange}
			disabled={disabled}
			// helperText={'Press enter to search'}
			fullWidth
			size='small'
			// FormHelperTextProps={{ style: { color: 'rgba(0, 0, 0, 0.3)' } }}
			slotProps={{
				input: {
					startAdornment: (
						<InputAdornment position='start'>
							<IconButton disabled={disabled} sx={{ padding: '0' }}>
								<SearchIcon />
							</IconButton>
						</InputAdornment>
					),
					endAdornment: (
						<InputAdornment position='end'>
							{query && query.length > 0 && (
								<IconButton
									size='small'
									disabled={disabled}
									sx={{ padding: '0' }}
									onClick={handleClear}
								>
									<ClearIcon fontSize='20px' />
								</IconButton>
							)}
						</InputAdornment>
					),
				},
			}}
		/>
	);
};

InstantSearchField.displayName = 'InstantSearchField';

export const InstantSearchFieldAdaptor = (props) => {
	const searchBoxApi = useSearchBox(props);
	return <InstantSearchField {...searchBoxApi} />;
};

InstantSearchFieldAdaptor.displayName = 'InstantSearchFieldAdaptor';

export default SearchField;
